import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'
import { normaliseResults, adjustPagination } from 'libs/searchspring/helpers/normalisers'
import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'
import { getMarketInStockTag } from 'libs/searchspring/searchspring-utils'

export class SearchspringCollection extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { handle, originalQuery, sort, filters, page, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('bgfilter.collection_handle', handle)

    const inStockTag = getMarketInStockTag()
    if (inStockTag) this.params.set('bgfilter.tags', inStockTag)

    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    if (sort) this.params.setSort(sort)
    else this.params.clearSort()
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export const SearchspringCollectionProvider = generateSearchspringProvider(SearchspringCollection, async (results) => {
  const normalisedResults = await normaliseResults(results.results)
  return adjustPagination(results, normalisedResults)
})
